import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import './UserDetailModal.css';

const UserDetailModal = ({ userid, isOpen, onClose, token }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && userid) {
      setLoading(true);
      axios
        .get(`/api/auth/profile/${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setUser(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('사용자 프로필 조회 실패:', err);
          setLoading(false);
        });
    }
  }, [isOpen, userid, token]);

  if (!isOpen) return null;

  // ✅ React Portal을 사용하여 body 최상단에 렌더링
  return ReactDOM.createPortal(
    <div className="user-modal-overlay" onClick={onClose}>
      <div className="user-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="user-modal-header">
          <h5 className="modal-title">사용자 상세 정보</h5>
          <button className="modal-close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="user-modal-body compact-mode">
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border spinner-border-sm text-primary mb-2"></div>
              <div className="small">불러오는 중...</div>
            </div>
          ) : user ? (
            <>
              <div className="user-profile-hero-compact mb-3">
                <div className="hero-avatar-wrapper-sm">
                  <img
                    src={user.photo_path && user.photo_path.trim() !== '' 
                      ? `${user.photo_path}?${new Date().getTime()}`
                      : '/images/img_org_noimage.png'}
                    alt=""
                    className="hero-avatar"
                    onError={(e) => { e.target.src = '/images/img_org_noimage.png'; }}
                  />
                </div>
                <div className="hero-text-sm">
                  <h3 className="hero-name-sm">{user.name}</h3>
                  <p className="hero-subtitle-sm">{user.dept_name || '-'} / {user.position || '-'}</p>
                </div>
              </div>

              <div className="info-card-unified">
                <div className="info-group mb-3">
                  <div className="group-label-line">기본 정보</div>
                  <div className="grid-2-col">
                    <div className="grid-item-sm">
                      <span className="label-sm">성명</span>
                      <span className="value-sm fw-bold">{user.name}</span>
                    </div>
                    <div className="grid-item-sm">
                      <span className="label-sm">아이디</span>
                      <span className="value-sm">{user.userid}</span>
                    </div>
                    <div className="grid-item-sm">
                      <span className="label-sm">부서</span>
                      <span className="value-sm">{user.dept_name || '-'}</span>
                    </div>
                    <div className="grid-item-sm">
                      <span className="label-sm">직책</span>
                      <span className="value-sm">{user.position || '-'}</span>
                    </div>
                  </div>
                </div>

                <div className="info-group">
                  <div className="group-label-line">기타 정보</div>
                  <div className="grid-2-col">
                    <div className="grid-item-sm">
                      <span className="label-sm">연락처</span>
                      <span className="value-sm"><i className="fas fa-phone-alt me-1 text-muted"></i>{user.phone || '-'}</span>
                    </div>
                    <div className="grid-item-sm">
                      <span className="label-sm">생일</span>
                      <span className="value-sm"><i className="far fa-calendar-alt me-1 text-muted"></i>{user.birthday || '-'}</span>
                    </div>
                    <div className="grid-item-sm full-width mt-1">
                      <span className="label-sm">이메일</span>
                      <span className="value-sm"><i className="far fa-envelope me-1 text-muted"></i>{user.email || '-'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="text-center py-4">정보가 없습니다.</div>
          )}
        </div>
        
        <div className="user-modal-footer-sm">
          <button className="btn-close-sm" onClick={onClose}>닫기</button>
        </div>
      </div>
    </div>,
    document.body // 👈 body 태그 바로 아래에 렌더링하여 모든 레이아웃 무시
  );
};

export default UserDetailModal;
